mutation SaveSunProtectionOrder(
    $dealId: Long!
    $productInputs: [SunProtectionProductInput!]!
    $signatureId: UUID
    $discountCode: String
    $role: SunProtectionOrderRole!
) {
    saveSunProtectionOrder(
        dealId: $dealId
        productInputs: $productInputs
        signatureId: $signatureId
        discountCode: $discountCode
        role: $role
    ) {
        id
    }
}
